


















import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class InputFormTextInquiry extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  content: string | null

  @Prop({ required: true })
  input: (value: string, field: string) => void

  // `content` への Mutating Props 対策として get と set を使用
  // 参照: https://github.com/my-color/front/issues/2943
  get contentValue (): string | null {
    return this.content
  }

  set contentValue (newValue: string | null) {
    this.input(newValue as string, 'content')
  }
}
